import React from 'react';

// Clean, brand-inspired SVG representations of UAE government authorities.
// Each renders in a compact viewBox suitable for logo grid cells.

export const AmerLogo = ({ className = '' }) => (
  <svg viewBox="0 0 120 70" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Amer">
    {/* Arabic script "أمر" - stylized */}
    <text x="70" y="30" fontFamily="'Cairo', 'Tajawal', serif" fontSize="22" fontWeight="700" fill="#0a2a5e" textAnchor="middle">أمر</text>
    {/* English "amer" */}
    <text x="60" y="55" fontFamily="'Inter', sans-serif" fontSize="16" fontWeight="500" fill="#0a2a5e" letterSpacing="1">amer</text>
    {/* UAE flag ribbon on right */}
    <g transform="translate(96 8)">
      <rect x="0" y="0" width="16" height="7" fill="#00732F"/>
      <rect x="0" y="7" width="16" height="7" fill="#fff" stroke="#ddd" strokeWidth="0.3"/>
      <rect x="0" y="14" width="16" height="7" fill="#000"/>
      <rect x="0" y="0" width="5" height="21" fill="#EF3340"/>
      <path d="M0 21 L16 21 L14 42 L2 42 Z" fill="#EF3340" opacity="0.9"/>
    </g>
  </svg>
);

export const MofaicLogo = ({ className = '' }) => (
  <svg viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Ministry of Foreign Affairs">
    {/* UAE emblem: golden falcon/eagle */}
    <g transform="translate(80 5)">
      <path d="M0 5 L-14 -2 L-20 5 L-16 15 L-8 20 L0 22 L8 20 L16 15 L20 5 L14 -2 Z" fill="#c8a24b"/>
      <ellipse cx="0" cy="10" rx="6" ry="9" fill="#c8a24b"/>
      <path d="M-3 8 Q0 4 3 8 Q0 12 -3 8" fill="#1e40af"/>
      <text x="0" y="35" fontSize="4" fill="#c8a24b" textAnchor="middle" fontFamily="'Cairo', serif">الإمارات</text>
    </g>
    {/* Arabic text */}
    <text x="80" y="55" fontSize="7.5" fill="#5a4520" textAnchor="middle" fontFamily="'Cairo', 'Tajawal', serif" fontWeight="700">وزارة الخارجية</text>
    <text x="80" y="65" fontSize="6" fill="#5a4520" textAnchor="middle" fontFamily="'Cairo', 'Tajawal', serif">والتعاون الدولي</text>
    <text x="80" y="76" fontSize="4.5" fill="#1e40af" textAnchor="middle" fontFamily="'Inter', sans-serif" letterSpacing="0.3">MINISTRY OF FOREIGN AFFAIRS</text>
    <text x="80" y="83" fontSize="4.5" fill="#1e40af" textAnchor="middle" fontFamily="'Inter', sans-serif" letterSpacing="0.3">&amp; INTERNATIONAL COOPERATION</text>
  </svg>
);

export const IcpLogo = ({ className = '' }) => (
  <svg viewBox="0 0 160 80" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Federal Authority for Identity & Citizenship">
    {/* Stylized eagle silhouette in warm gold */}
    <g transform="translate(80 20)">
      <path d="M0 -10 Q-8 -5 -12 5 Q-6 8 0 10 Q6 8 12 5 Q8 -5 0 -10 Z" fill="#2563eb"/>
      <path d="M-15 0 Q-20 4 -22 10 Q-18 8 -12 6" fill="#2563eb" opacity="0.85"/>
      <path d="M15 0 Q20 4 22 10 Q18 8 12 6" fill="#2563eb" opacity="0.85"/>
      <circle cx="0" cy="-2" r="1.5" fill="#0a2a5e"/>
    </g>
    <text x="80" y="50" fontSize="7" fill="#0a2a5e" textAnchor="middle" fontFamily="'Cairo', 'Tajawal', serif" fontWeight="700">الهيئة الاتحادية للهوية والجنسية</text>
    <text x="80" y="63" fontSize="4.5" fill="#0a2a5e" textAnchor="middle" fontFamily="'Inter', sans-serif" letterSpacing="0.3" fontWeight="600">FEDERAL AUTHORITY FOR IDENTITY</text>
    <text x="80" y="71" fontSize="4.5" fill="#0a2a5e" textAnchor="middle" fontFamily="'Inter', sans-serif" letterSpacing="0.3" fontWeight="600">&amp; CITIZENSHIP</text>
  </svg>
);

export const DubaiChamberLogo = ({ className = '' }) => (
  <svg viewBox="0 0 200 70" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Dubai Chamber">
    {/* Arabic side */}
    <text x="60" y="30" fontSize="22" fill="#2563eb" textAnchor="middle" fontFamily="'Cairo', 'Tajawal', serif" fontWeight="700">غرفة دبي</text>
    {/* Divider */}
    <line x1="115" y1="15" x2="115" y2="45" stroke="#2563eb" strokeWidth="1"/>
    {/* English */}
    <text x="120" y="27" fontSize="16" fill="#0a2a5e" fontFamily="'Inter', sans-serif" fontWeight="800" letterSpacing="1">DUBAI</text>
    <text x="120" y="43" fontSize="14" fill="#0a2a5e" fontFamily="'Inter', sans-serif" fontWeight="600" letterSpacing="1">CHAMBER</text>
    {/* Accent gold underline */}
    <rect x="120" y="47" width="55" height="1.5" fill="#2563eb"/>
  </svg>
);

export const DubaiTourismLogo = ({ className = '' }) => (
  <svg viewBox="0 0 180 70" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Dubai Tourism">
    {/* Dubai stylized */}
    <text x="90" y="35" fontSize="30" fill="#1F72CD" textAnchor="middle" fontFamily="'Inter', sans-serif" fontWeight="900" letterSpacing="1">DUBAI</text>
    {/* Small arabic tail */}
    <path d="M138 22 Q150 20 152 28 Q148 30 140 28" fill="#1F72CD" opacity="0.85"/>
    <text x="90" y="55" fontSize="14" fill="#1F72CD" textAnchor="middle" fontFamily="'Cairo', 'Tajawal', serif" fontWeight="600">Tourism <tspan fill="#1F72CD">للسياحة</tspan></text>
  </svg>
);

export const DubaiCustomsLogo = ({ className = '' }) => (
  <svg viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Dubai Customs">
    {/* Eagle & shield emblem */}
    <g transform="translate(80 20)">
      {/* wings */}
      <path d="M-25 0 Q-30 -5 -32 5 Q-28 12 -18 10 Z" fill="#0a2a5e"/>
      <path d="M25 0 Q30 -5 32 5 Q28 12 18 10 Z" fill="#0a2a5e"/>
      {/* Head */}
      <path d="M0 -12 Q-4 -8 -3 -4 L0 -3 L3 -4 Q4 -8 0 -12 Z" fill="#0a2a5e"/>
      <circle cx="1" cy="-8" r="0.8" fill="#2563eb"/>
      {/* Shield */}
      <path d="M-10 -3 L10 -3 L10 8 Q10 14 0 18 Q-10 14 -10 8 Z" fill="#0a2a5e"/>
      <path d="M-10 -3 L0 -3 L0 18 Q-10 14 -10 8 Z" fill="#1a4585"/>
      <rect x="-1" y="-1" width="2" height="16" fill="#2563eb"/>
    </g>
    <text x="80" y="55" fontSize="9" fill="#0a2a5e" textAnchor="middle" fontFamily="'Cairo', 'Tajawal', serif" fontWeight="700">جمارك دبي</text>
    <text x="80" y="70" fontSize="8" fill="#0a2a5e" textAnchor="middle" fontFamily="'Inter', sans-serif" fontWeight="700" letterSpacing="1.5">DUBAI CUSTOMS</text>
  </svg>
);

export const authorities = [
  { key: 'amer', Logo: AmerLogo, name: { en: 'Amer', ar: 'أمر' } },
  { key: 'mofaic', Logo: MofaicLogo, name: { en: 'Ministry of Foreign Affairs', ar: 'وزارة الخارجية' } },
  { key: 'icp', Logo: IcpLogo, name: { en: 'Federal Authority for Identity & Citizenship', ar: 'الهيئة الاتحادية للهوية والجنسية' } },
  { key: 'dubaichamber', Logo: DubaiChamberLogo, name: { en: 'Dubai Chamber', ar: 'غرفة دبي' } },
  { key: 'dubaitourism', Logo: DubaiTourismLogo, name: { en: 'Dubai Tourism', ar: 'دبي للسياحة' } },
  { key: 'dubaicustoms', Logo: DubaiCustomsLogo, name: { en: 'Dubai Customs', ar: 'جمارك دبي' } }
];
